/* eslint-disable camelcase */
import { SMARTPAK, PORTIONPAK } from '../../constants/producttypes';
import { roundedToFixed } from '../../utils/number';

export default function formatCartItemsForEvents(items) {
    if (!Array.isArray(items)) {
        throw new Error('formatCartItemsForEvents requires an array of items as an argument.');
    }

    const format = ({
        IsAutoShip,
        Brand,
        ProductId,
        ProductClassId,
        ProductClassName,
        ParentReportingCategory,
        ChildReportingCategory,
        Quantity,
        Price,
        ProductType
    }) => {
        return {
            IsAutoShip,
            Brand,
            ProductId: ProductId.toString(),
            ItemNumber: (ProductClassId + 10000).toString(),
            ProductClassName,
            ParentReportingCategory,
            ChildReportingCategory,
            Quantity: Quantity.toString(),
            Price: Price.toString(),
            IsSmartPak: ProductType === SMARTPAK
        };
    };

    return items
        .reduce((arr, item) => {
            const { IsAutoShip, SupplementViewModels, ProductType } = item;

            if (ProductType === SMARTPAK || item.ProductType === PORTIONPAK) {
                SupplementViewModels.forEach(product => {
                    arr.push(format({
                        ...product,
                        Price: roundedToFixed(product.DiscountedPrice, 2),
                        ProductType,
                        IsAutoShip
                    }));
                });
            } else {
                arr.push(format({
                    ...item,
                    Price: roundedToFixed(item.UnitPrice, 2),
                    ProductType,
                    IsAutoShip
                }));
            }

            return arr;
        }, []);
}